function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.758,2.054,7.373.067a1.076,1.076,0,0,0-.746,0L1.242,2.054a1.079,1.079,0,0,0-.7,1.011V6.047a7.885,7.885,0,0,0,6.292,7.94,1.039,1.039,0,0,0,.34,0,7.885,7.885,0,0,0,6.292-7.94V3.065A1.079,1.079,0,0,0,12.758,2.054Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "currentColor"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/shield.7f10f5e3.svg";
export { SvgComponent as ReactComponent };